import React from 'react';
import './GeneralInformations.css';

const calcAge = (raw) => {
  if (!raw) return null;
  try {
    const s = String(raw || '').trim();
    if (!s) return null;

    // Accept ISO date, timestamp, or Date
    const d = new Date(s);
    if (Number.isNaN(d.getTime())) return null;

    const today = new Date();
    let age = today.getFullYear() - d.getFullYear();
    const m = today.getMonth() - d.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < d.getDate())) {
      age -= 1;
    }
    return age >= 0 ? age : null;
  } catch (e) {
    return null;
  }
};

const GeneralInformations = ({ patientData, patientId }) => {
  const p = patientData || patientId || {};

  const dob = p?.birthDate || p?.dateOfBirth || p?.birthdate || p?.birth;
  const age = calcAge(dob);

  return (
    <div className="general-info-container">
      <h3 className="general-info-title">General Informations :</h3>
      <div className="info-grid">
        <div className="info-row">
          <span className="info-label">Gender :</span>
          <span className="info-value">{p?.gender || 'Female'}</span>
          <span className="info-label">Age :</span>
          <span className="info-value-center">{age != null ? `${age} yrs` : '—'}</span>
        </div>
        <div className="info-row">
          <span className="info-label">Blood type :</span>
          <span className="info-value">{p?.bloodType || 'O+'}</span>
          <span className="info-label weight-label">Weight :</span>
          <span className="info-value-center">{p?.weight || '56 Kg'}</span>
        </div>
        <div className="info-row">
          <span className="info-label">Height :</span>
          <span className="info-value">{p?.height || '1.65 m'}</span>
          <span className="info-label">Latest visit :</span>
          <span className="info-value-center">{p?.latestVisit || '28-03-2025'}</span>
        </div>
        <div className="info-row diseases-row">
          <span className="info-label">Diseases :</span>
          <span className="info-value diseases-value">{p?.diseases || 'Blood pressure'}</span>
        </div>
      </div>
    </div>
  );
};

export default GeneralInformations;
